import React from "react";
import Header from "../header/Header";
import Title from "./Title";
import Table from "./Table";

const Liquidate = () => {
  return (
    <div>
      <Header />
      <Title />
      <Table />
    </div>
  );
};

export default Liquidate;
